export default "__VITE_ASSET__CUDtDoyM__"